import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'avatarChange-action',
    templateUrl:'avatarChangeAction.html'
})
export class AvatarChangeActionComponent extends BaseActionComponent{


  public models;
  public text;
  public media;
  public kind='';
  public level=1;
  public linkForm: FormGroup;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }

  //Modelos de NPC: this._appData.room.textures.models filtrado por model.npc == true
  public reloadModels(){
    let list=[]
    if (this._appData.room && this._appData.room.textures && this._appData.room.textures.models){
      list=this._appData.room.textures.models
    }
    this.models=[]
    list.filter(m=>{
      return m && (m.kind=='npc')
    }).forEach(ic=>{
      if (!ic.id){ic.id=ic.transaction}
      let model={
        kind:'model',
        id:ic.id,
        url:ic.model,
        name:ic.name ? ic.name : ic.id,
        img:ic.img ? ic.img : '',
        selected:false
      }
      if (this.kind=='model' && this.media && this.media.id==model.id){
        model.selected=true
      }
      this.models.push(model)
    })
  }
  /////////////////////////////////////////////////////////////////////
  // SELECAO (uma opcao por vez, video OU modelo)
  /////////////////////////////////////////////////////////////////////
  public selectItem(item){
    this.kind=item.kind
    this.media=item
    this.models.forEach(m=>{
      m.selected = this.kind=='model' ? (m.id==item.id) : false
    })
  }
  public clearSelection(){
    this.kind=''
    this.media=null
    if (this.models){
      this.models.forEach(m=>{m.selected=false})
    }
  }
  public gotoLink(item){
    if (item && item.url){
      window.open(item.url, '_blank');
    }
  }
  /////////////////////////////////////////////////////////////////////
  // PERSISTENCIA
  /////////////////////////////////////////////////////////////////////
  public processData(action){
    if (!action){
      action={kind:'avatarChange',param:{}}
    }
    if (!action.param){
      action.param={}
    }
    if (this.media){
      if (this.kind=='model'){
        //segue a convencao de modelo usada no item (item.model = 'model-'+id)
        action.param.kind='model'
        action.param.url='model-'+this.media.id
        action.param.photo=this.media.url
        action.param.model=this.media.url
        action.param.thumb=this.media.img ? this.media.img : ''
      }
      else{
        action.param.kind='video'
        action.param.url='video-'+this.media.id
        action.param.video=this.media.url
        action.param.thumb=this.media.img ? this.media.img : ''
      }
      action.param.id=this.media.id
      action.param.name=this.media.name
    }
    else{
      action.param.kind=''
      action.param.url=''
      action.param.video=''
      action.param.model=''
      action.param.photo=''
      action.param.thumb=''
      action.param.id=''
      action.param.name=''
    }
    action.param.text=this.text ? this.text : ''
    action.param.room=this._appData.room.id;
  }
  public updateEmbed(){
    this.text=this.linkForm.controls['linkParam'].value;
  }
  /////////////////////////////////////////////////////////////////////
  // RELOAD
  /////////////////////////////////////////////////////////////////////
  public childrenReloadData(){
    let param=this.action.param ? this.action.param : {};
    this.kind=param.kind ? param.kind : '';
    this.media=null
    if (this.kind && param.id){
      this.media={kind:this.kind,id:param.id,name:param.name,url:this.kind=='model' ? param.model : param.video,img:param.thumb}
    }
    if (param.text){
      this.text=param.text;
      this.linkForm = this.fb.group({
        linkParam: param.text,
      });
    }
    else{
      this.text='';
      this.linkForm = this.fb.group({
        linkParam: '',
      });
    }

    this.reloadModels();
  }

    public ngOnInit(): any {
      this.linkForm = this.fb.group({
        linkParam: '',
      });
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/avatarChangeAction.ts